export const SOURCE_PLUGILO = "plugilo";
export const SOURCE_EMAIL = "email";
export const SOURCE_WIDGET = "infoboard";
export const SOURCE_TRIGGER_TEXT = "trigger-text";
export const SOURCE_PLUGIT = "plugit";
export const SOURCE_LIGHTWEIGHT = "LP";
export const SOURCE_MOBILE = "mobile";
export const SOURCE_EXTENSION = "extension";
